import * as React from "react";
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import styles from "./bookingSection.module.css";

export default function RatingComponent({ setAskRating }) {
  const [value, setValue] = React.useState(3);
  const boxRef = React.useRef(null);

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setAskRating(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setAskRating]);

  return (
    <Box
      ref={boxRef}
      className={styles.fadeIn}
      sx={{
        backgroundColor: "grey",
        width: "fit-content",
        padding: "16px",
        borderRadius: "16px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.6)",
      }}
    >
      <Typography component="legend">{"Rate your artist 🏆"}</Typography>
      <Rating
        name="simple-controlled"
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
          setTimeout(() => {
            setAskRating(false);
          }, [2000]);
        }}
      />
    </Box>
  );
}
